import { Instagram } from "lucide-react";
import { MaskLines, Reveal } from "@/components/Motion";
import { imgPos } from "@/lib/api";
import { GALLERY, INSTAGRAM, HANDLE } from "@/data/site";

export const InstaGallery = () => (
  <section data-testid="instagram-section" className="bg-linen py-28 md:py-44 overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14 md:mb-20">
        <div>
          <p className="eyebrow mb-6">From the Studio</p>
          <MaskLines lines={["Follow along", <span className="italic text-mocha">on Instagram.</span>]} className="font-display font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95]" />
        </div>
        <Reveal>
          <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="instagram-handle-link" className="group inline-flex items-center gap-3 font-display text-2xl md:text-3xl italic">
            <Instagram className="w-5 h-5" strokeWidth={1.4} />
            <span className="link-u pb-1">{HANDLE}</span>
          </a>
        </Reveal>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {GALLERY.slice(0, 6).map((g, i) => (
          <Reveal key={g.src} delay={i * 0.04}>
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid={`instagram-tile-${i}`} className="group relative block aspect-[4/5] overflow-hidden bg-[#F1EDE4]">
              <img src={g.src} alt={g.alt} className={`absolute inset-0 w-full h-full object-cover ${imgPos(g.src)} transition-transform duration-[1.4s] group-hover:scale-110`} />
              <span className="absolute inset-0 bg-espresso/55 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center text-cream">
                <Instagram className="w-6 h-6" strokeWidth={1.3} />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
